import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'dateTiny'
})
export class DateTinyPipe implements PipeTransform {
  transform(value: Date | string): string | null {
    const date = new Date(value);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    return `${day}/${month}`;
  }
}
